/* Grippatch - hero arka plan gecisi */

function initHero(root) {
  const slides = root.querySelectorAll('[data-hero-slide]');
  const dots = root.querySelectorAll('[data-hero-dot]');
  if (slides.length < 2) return;

  // Hareket azaltma tercihinde OTOMATIK gecis kapanir; ok ve noktalar
  // calismaya devam eder (aksi halde slayt hic gezilemezdi).
  const autoplay = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const delay = parseInt(root.dataset.speed, 10) || 6000;
  let i = 0;
  let timer = null;

  const show = (n) => {
    slides[i].classList.remove('is-on');
    if (dots[i]) dots[i].classList.remove('is-on');
    i = (n + slides.length) % slides.length;
    slides[i].classList.add('is-on');
    if (dots[i]) dots[i].classList.add('is-on');
  };

  const start = () => {
    stop();
    if (!autoplay) return;
    timer = window.setInterval(() => show(i + 1), delay);
  };

  const stop = () => {
    if (timer) {
      window.clearInterval(timer);
      timer = null;
    }
  };

  dots.forEach((dot) => {
    dot.addEventListener('click', () => {
      show(parseInt(dot.dataset.heroDot, 10) || 0);
      start();
    });
  });

  // Kenar oklari (referanstaki dairesel prev/next)
  const prev = root.querySelector('[data-hero-prev]');
  const next = root.querySelector('[data-hero-next]');
  if (prev) {
    prev.addEventListener('click', () => {
      show(i - 1);
      start();
    });
  }
  if (next) {
    next.addEventListener('click', () => {
      show(i + 1);
      start();
    });
  }

  document.addEventListener('visibilitychange', () => (document.hidden ? stop() : start()));

  start();
}

function initAllHeroes() {
  document.querySelectorAll('[data-hero]').forEach((el) => {
    if (el.dataset.ready === '1') return;
    el.dataset.ready = '1';
    initHero(el);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllHeroes);
} else {
  initAllHeroes();
}

document.addEventListener('shopify:section:load', initAllHeroes);
